module.exports = __webpack_public_path__ + "static/img/3.4abe2b8f.jpg";